export default function convertSecondsToTime(seconds: number) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = parseInt((seconds % 60).toString());

  return `${minutes}m ${remainingSeconds}s`;
}
